<template>
  <div
    class="layout-default"
    :class="{ 'layout-default--dark': darkMode }"
  >
    <header class="layout-default__header">
      <div class="layout-default__header__container">
        <Logo class="layout-default__header__logo" />

        <div class="layout-default__header__tray">
          <DarkModeSwitcher />
          <LangSwitcher />
        </div>
      </div>
    </header>

    <main
      class="layout-default__main"
      :class="{ 'layout-default__main--centered': loading || centered }"
    >
      <div class="layout-default__main__container">
        <transition
          name="transition-1"
          mode="out-in"
        >
          <RouterView />
        </transition>

        <div
          class="layout-default__main__loader"
          v-if="loading"
        >
          <FontAwesomeIcon icon="spinner" spin />
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'IndexView',

  computed: {
    ...mapState('global', [
      'loading',
      'centered',
      'darkMode'
    ])
  }
}
</script>
